import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-yandex-map-old',
  templateUrl: './yandex-map.component.html',
  styleUrls: ['./yandex-map.component.scss'],
})
export class YandexMapOldComponent {
  @Input()
  public readonly width: string = '500px';

  @Input() coordinates: any[];
}
